export const styles = theme => ({
  loadingShading: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    background: 'rgba(255, 255, 255, .3)',
  },
  
  loadingIcon: {
    position: 'absolute',
    top: 'calc(45% - 10px)',
    left: 'calc(48% + 100px)',
    [theme.breakpoints.down('xs')]: {
      left: 'calc(45% - 10px)',
    }
  }
})
